export default {"src":"/_next/static/media/jumgoro.c3cdf417.gif","height":100,"width":100,"blurWidth":0,"blurHeight":0};